import React, { Component } from "react";
import PurchaseRegisterBody from "./PurchaseRegisterBody";

class PurchaseRegister extends Component {
  render() {
    return (
      <div className="animated fadeIn">
        <PurchaseRegisterBody />
      </div>
    );
  }
}

export default PurchaseRegister;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/PurchaseRegister.js